import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { GIButton } from 'app-components';
import { FormattedMessage } from 'react-intl';
import { configs } from '@constants/configs/configs';
import Table from '../../common/table/Table';
import { ConditionalRendering } from '../../common/conditional-rendering';

const StyledTable = styled(Table)({
    'th, td': {
        alignContent: 'center',
    },
    'th:nth-child(3), td:nth-child(3)': {
        width: '220px',
    },
    'th:first-child, td:first-child': {
        width: '24% !important',
    },
});

const StyledButtonContainer = styled.div`
    display: flex;
    justify-content: end;
`;

const EligibilityDetails = (props) => {
    const { eligibilityDetails, btnData, showVoterRegistration, ssapApplicationId, caseNumber } = props;
    const navigate = useNavigate();

    const navigateToVoterRegistration = () => {
        navigate(configs.routes.VOTER_REGISTRATION, {
            state: {
                ssapApplicationId,
                caseNumber
            },
        });
    };

    return (
        <div className="eligibility-details">
            <FormattedMessage id="eligibility_results.details.header" tagName="h3" />
            <StyledTable data={eligibilityDetails.data} columns={eligibilityDetails.columns} />

            <StyledButtonContainer>
                <ConditionalRendering isTrue={showVoterRegistration}>
                    <GIButton
                        id="eligibilityDetailsVoterRegistration"
                        onClickHandler={navigateToVoterRegistration}
                        variant='secondary'
                        labelId={'eligibility_results.voter_registration'}
                        data-testid="eligibilityDetailsVoterRegistration-button"
                    />
                </ConditionalRendering>

                <ConditionalRendering isTrue={!!btnData}>
                    <GIButton
                        id="eligibilityDetailsGoTo"
                        onClickHandler={btnData.btnCb}
                        addlClassNames="usa-button  gi-button gi-button__primary eligibility_CTA"
                        label={btnData.btnText}
                        data-testid="eligibilityDetailsGoTo-button"
                    />
                </ConditionalRendering>
            </StyledButtonContainer>
        </div>
    );
};

export default EligibilityDetails;
